import { ActivatedRouteSnapshot } from '@angular/router';

export class UrlBuilderHelper {
  /**
   * Builds the final URL path by extracting dynamic parameters from the route snapshot.
   * @param routePath The Angular route path (e.g. ':projectSlug/areas/:areaId').
   * @param snapshot The current ActivatedRouteSnapshot containing route params.
   *
   * @returns The final URL path with the route parameters replaced (e.g. 'myProject/areas/123').
   */
  public static buildUrlPath(routePath: string, snapshot: ActivatedRouteSnapshot): string {
    return routePath.replace(/:([a-zA-Z0-9]+)/g, (match, paramName) => {
      const paramValue = snapshot.paramMap.get(paramName);

      if (!paramValue) {
        throw new Error(`Missing route parameter: ${paramName}`);
      }

      return paramValue;
    });
  }

  /**
   * Normalize a domain/hostname input by removing protocol, path and port.
   *
   * @param hostname Hostname or URL value to normalize.
   * @returns Normalized hostname in lowercase.
   */
  public static normalizeHostname(hostname: string): string {
    return hostname.trim().toLowerCase()
      .replace(/^https?:\/\//, '')
      .replace(/\/.*$/, '')
      .replace(/:\d+$/, '');
  }

  /**
   * Checks if the current environment is local development.
   * @returns True if running on localhost or local development environment.
   */
  public static isLocalDevelopment(): boolean {
    return window.location.hostname === 'localhost'
      || window.location.hostname === '127.0.0.1'
      || window.location.hostname.includes('local');
  }
}
